module.exports = __webpack_public_path__ + "static/fire_elemental_myrmidon-7b8a1e201af86ec0dec1f50e0b8f0c51.png";